<template>
  <div class="isTxt" v-if="isTxt">
    {{ innerValue || '-' }}
  </div>
  <el-date-picker
    v-else
    style="width: 100%"
    v-model="innerValue"
    :type="renderConfig.type"
    :format="renderConfig.format"
    :value-format="renderConfig.format"
    :placeholder="renderConfig.placeholder"
    :start-placeholder="renderConfig.placeholder"
    :disabled="renderConfig.disabled"
    :shortcuts="shortcuts"
    :end-placeholder="renderConfig.placeholder"
    @change="handleChange"
  />
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'blur'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
const shortcuts = computed(() => {
  return props.data.shortcuts || []
})
onMounted(() => {
  if (!props.modelValue) {
    // 关联已有数据
    if (props.data.defaultMark === 1) {
      getAssociatedData(props).then((res: Recordable) => {
        innerValue.value = res?.value || ''
      })
    }
  }
})

function handleChange() {
  emit('blur', innerValue.value)
}

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>
